import { render, staticRenderFns } from "./SuperNavInventro.vue?vue&type=template&id=b295c326&scoped=true&"
import script from "./SuperNavInventro.vue?vue&type=script&lang=js&"
export * from "./SuperNavInventro.vue?vue&type=script&lang=js&"
import style0 from "./SuperNavInventro.vue?vue&type=style&index=0&id=b295c326&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b295c326",
  null
  
)

export default component.exports